import { Component, Input, OnInit } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
  selector: "hawk-throbber",
  templateUrl: "./throbber.component.html",
  styleUrls: ["./throbber.component.scss"],
  standalone: true,
})
export class ThrobberComponent {
  @Input() description: string;
  @Input() backgroundColor: string = "rgba(0, 0, 0, 0.849)";
  @Input() direction: "horizontal" | "vertical" = "vertical";
}
